import { Pipe, PipeTransform } from '@angular/core';
import { NgModule } from '@angular/core';
import { cgpAuthentication } from '../../../modules/cgp-authentication';
import { NameByIdPipe } from './module-name.pipe';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';

@Pipe({ name: 'person' })
export class PersonPipe implements PipeTransform {
    transform(data: any) {
        let _url: string;
        if (data && (data.GMIN || data.Gmin || data.gmin || data.OwnerGmin)) {
            let _gmin = data.GMIN ? data.GMIN : data.Gmin ? data.Gmin : data.gmin ? data.gmin : data.OwnerGmin;
            _gmin = _gmin.toString();

            let _path = _gmin.substr(0, 3) + '/' + _gmin.substr(3, 3) + '/' + _gmin + '_lthumb.jpg';
            _url = 'https://peoplefinder.gm.com/photos/' + _path;
        }
        return _url;
    }
}


@Pipe({ name: 'activeUser' })
export class ActiveUserPipe implements PipeTransform {
    transform(control: any = undefined) {
        try {
            let user = cgpAuthentication.getUserInfo(),
                gmin = user.gmuniqueidentifier || user.gmin,
                path = gmin.substr(0, 3) + '/' + gmin.substr(3, 3) + '/' + gmin + '_lthumb.jpg',
                url = 'https://peoplefinder.gm.com/photos/' + path;
            user.imageUrl = url;
            return user;
        } catch (e) {
            return null;
        }
    }
}



@Pipe({ name: 'columnTemplate' })
export class ColumnTemplatePipe implements PipeTransform {
    transform(column: any, dataItem: any) {
        let response: any;
        switch (column.template.type) {
            case "boolean":
                let label = dataItem[column.field] ? column.template.onLabel : column.template.offLabel;
                let disabledClass: string;

                if (column.template.field && column.template.operation) {
                    let check = dataItem[column.template.field];
                    let isDisabled = column.template.operation === 'equals' ?
                        check : !check;
                    disabledClass = isDisabled ? "disabled" : "";
                }
                response = `<span class='${disabledClass}'>${label}</span>`;
                break;
            case "filter":
                let _filter = column.template.filter,
                    _field = _filter ? _filter.field : undefined,
                    _check = _filter ? _filter.check : undefined;
                response = new NameByIdPipe()
                    .transform(dataItem[column.field], column.template.dataSource.data, _field, _check);
                break;
            case "email":
                let addr: string = dataItem[column.field] ? dataItem[column.field] : "";
                response = `<a class="k-link mail-link" href='mailto:${addr}'>${addr}</a>`;
                break;
            case "link":
                let link: string = dataItem[column.field] ? dataItem[column.field] : "";
                if (link && !link.startsWith('http')) link = "http://" + link;
                response = `<a class="k-link mail-link" href='${link}' target='_blank'>${link}</a>`;
                break;
            case "combobox":
                response = `${dataItem[column.field]}`;
                break;
            case "date":
                if (dataItem[column.field] === "" || dataItem[column.field] === null || !dataItem[column.field]) {
                    response = "";
                }
                else {
                    let _date = new DatePipe('en-US')
                        .transform(dataItem[column.field], column.template.dateFormat);
                    response = `${_date}`;
                }
                break;
            case "person":
                let url = new PersonPipe()
                    .transform(dataItem);
                response = `<img class="user-photo" src="${url}">`;
                break;
            case "user":
                response = new UserPipe()

                    .transform(dataItem, column);
                break;
            case "customStyle":
                let val: string = dataItem[column.field];
                if (column.class) {
                    response = `<div class="column.class">${val}</div>`;
                }
                else if (column.template.setClass) {
                    let className = column.template.setClass(val);
                    response = `<div class="${className}">${val}</div>`
                }
                else {
                    response = `<div>${val}</div>`
                }
                break;
            default:
                break;
        }
        return response;
    }
}


@Pipe({ name: 'formControlPipe' })
export class FormControlPipe implements PipeTransform {
    transform(data: any, control: any) {
        let response: any;
        switch (control.pipe) {
            case "date":
                let _date = new DatePipe('en-US')
                    .transform(data, control.dateFormat);
                response = `${_date}`;
                break;
            case "filter":
                // console.log('FormControlPipe called.', data, control);
                response = new NameByIdPipe()
                    .transform(data, control.service.data, control.field, control.check);
                break;
            default:
                response = data;
                break;
        }
        return response;
    }
}

@Pipe({ name: 'user' })
export class UserPipe implements PipeTransform {
    transform(data: any, column: any) {
        let response = "";
        let _gmin = data.GMIN ? data.GMIN : data.Gmin ? data.Gmin : data.gmin ? data.gmin : data.OwnerGmin;
        try {
            let service: any[] = column.template.service.value,
                user = service.find(x => x.GMIN === _gmin);
            let url = new PersonPipe()
                .transform(data);
            let image = `<img class="user-photo" src="${url}">`,
                userDetails = `<span>${user.FirstName} ${user.LastName}</span>`;
            response = `<span>${image}${userDetails}</span>`;
        } catch (e) {
            return _gmin;
        }
        return response;
    }
}

